<template>
  <div class="custom-table">
    <div class="custom-table-header">
      <Button
        v-if="showCustomColumns"
        class="custom-table-column"
        @click="handleCustomColumnButtonClick"
      >
        自定义列
      </Button>

      <CustomColumn
        v-if="showCustomColumns"
        :dataSource="defaultCustomColumns"
        :visible.sync="visible"
        @change="handleCustomColumnChange"
      />

      <!-- <Button
        type="primary"
        @click="handleDownloadButtonClick"
      >
        下载数据（Excel）
      </Button> -->
      <DownloadReport
        v-if="showDownload"
        :topic="topic"
        :args="args"
      />
    </div>

    <DynamicTable
      v-bind="$attrs"
      :summaryTip="summaryTip"
      :columns="displayColumns"
      :dataSource="list"
      :summary="summary"
      :total="total"
      v-on="$listeners"
      @sort-change="handleDynamicTableSortChange"
      @filter-change="handleDynamicTableFilterChange"
    >
      <template v-slot:column="data">
        <slot
          name="column"
          :data="data.data"
        >
          {{ data.data.value || '-' }}
        </slot>
      </template>
    </DynamicTable>
  </div>
</template>

<script>
import { kebabCase, cloneDeep } from 'lodash';
import { Button } from 'element-ui';

import CustomColumn from '@/components/CustomColumn/Index';
import DynamicTable from '@/components/DynamicTable/Index';
import DownloadReport from '@/components/DownloadReport/Index';

import * as $cache from '@/common/cache';
import { getFieldsByGroup, getFieldsByBranches } from '@/config/columns/';
import { isEmpty } from '@/common/util/';

// 生成本地缓存 key
// const LOCAL_STORAGE_KEY = `CRM-${kebabCase(location.pathname).toUpperCase()}`;

export default {
  components: {
    Button,

    CustomColumn,
    DynamicTable,
    DownloadReport,
  },

  props: {
    // 自定义列
    showCustomColumns: {
      type: Boolean,
      default() {
        return true
      }
    },
    spliceIndex: {
      type: Number,
      default() {
        return -1
      }
    },

    showDownload: {
      type: Boolean,
      default() {
        return true
      }
    },

    customColumns: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },

    // 固定列
    fixedColumns: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },

    // 原始数据
    dataSource: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    // 下载报表类型
    topic: {
      type: String,
      default: '',
    },

    // 下载报表参数
    args: {
      type: Object,
      default() {
        return {};
      },
    },
    summaryTip: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
      visible: false,

      // 默认展示的自定义列信息
      defaultCustomColumns:
        this.getLocalStorageFields() || getFieldsByGroup(this.customColumns),

      // 默认展示的固定列信息
      defaultFixedColumns: getFieldsByGroup(this.fixedColumns),
    };
  },

  computed: {
    // 全部列
    columns() {
      const fixed = this.defaultFixedColumns;
      const custom = this.getSelectedFields(this.defaultCustomColumns);
      // const final = fixed.concat(custom);
      const _spliceIndex = this.spliceIndex === -1 ? fixed.length : this.spliceIndex
      const final = [
        ...fixed.slice(0, _spliceIndex),
        ...custom,
        ...fixed.slice(_spliceIndex)
      ];

      return final;
    },

    // 展示用的列
    displayColumns() {
      return getFieldsByBranches(this.columns);
    },

    fields() {
      return this.getRequestFields(this.columns);
    },

    list() {
      const { list } = this.dataSource;
      return isEmpty(list) || [];
    },

    summary() {
      const { summary } = this.dataSource;
      return isEmpty(summary) || {};
    },

    total() {
      return this.dataSource.total || 0;
    },
  },

  created() {
    this.$emit('created', this.fields);
  },

  methods: {
    createLocalStorageKey() {
      return `CRM-${kebabCase(location.pathname).toUpperCase()}`;
    },

    // 点击自定义列按钮
    handleCustomColumnButtonClick() {
      this.visible = true;
    },

    // 修改自定义列
    handleCustomColumnChange(options) {
      const key = this.createLocalStorageKey();
      $cache.localSet(key, options);
      this.defaultCustomColumns = options;
      this.$emit('change-columns', this.fields);
    },

    // 下载数据
    // handleDownloadButtonClick() {
    //   this.$emit('download');
    // },

    // 更改排序
    handleDynamicTableSortChange(sort) {
      this.$emit('sort-change', sort);
    },

    // 更改过滤
    handleDynamicTableFilterChange(filter) {
      this.$emit('filter-x-change', filter);
    },

    // 获取本地缓存的列信息
    getLocalStorageFields() {
      const key = this.createLocalStorageKey();
      return $cache.localGet(key);
    },

    // 获取接口请求用的参数
    getRequestFields(list) {
      return list.reduce((prev, current) => {
        if (current.children) {
          current.children.forEach((item) => {
            prev.push(item.key);
          });
        } else {
          prev.push(current.key);
        }
        return prev;
      }, []);
    },

    // 获取选中的自定义列
    getSelectedFields(list) {
      const _list = cloneDeep(list);
      return _list.filter((item) => {
        if (item.children) {
          const selected = item.children.filter((it) => {
            return it.isSelected;
          });
          item.children = selected;
          return selected.length > 0;
        } else {
          return item.isSelected;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.custom-table {
  &-header {
    float: right;
    margin-bottom: 20px;
  }

  &-column {
    margin-right: 20px;
  }
}
</style>